import { SET_CONNECTION } from 'redux/types'

const setConnection = (payload) => {
  return { type: SET_CONNECTION, payload }
}

export {
    setConnection
}